import { get } from './http';

export interface DashboardCardMetrics {
  solutionPublishedCount: number;
  solutionMonthNew: number;
  toolPublishedCount: number;
  toolMonthNew: number;
  memberTotalCount: number;
  memberMonthNew: number;
  monthViews: number;
  monthViewsPrev: number;
  monthViewsTrendPct: number;
}

export interface DashboardWeeklyViewPoint {
  date: string;
  label: string;
  value: number;
}

export interface DashboardMonthlyTrendItem {
  monthKey: string;
  monthLabel: string;
  visits: number;
  members: number;
  downloads: number;
}

export interface DashboardMemberGrowthItem {
  monthKey: string;
  monthLabel: string;
  total: number;
  vip: number;
}

export interface DashboardTopSolutionItem {
  id: number;
  title: string;
  views: number;
  trendPct: number;
}

export interface DashboardTopToolItem {
  id: number;
  name: string;
  downloads: number;
  trendPct: number;
}

export interface DashboardLatestMemberItem {
  id: number;
  name: string;
  company: string | null;
  membershipTier: 'member' | 'vip' | string;
  createdAt: string | null;
}

export interface DashboardActivityItem {
  id: number;
  moduleKey: string;
  actionType: string;
  targetText: string;
  operatorName: string;
  createdAt: string | null;
}

export interface DashboardInteractionStats {
  checkinsToday: number;
  checkins7d: number;
  likesToday: number;
  likes7d: number;
  sharesToday: number;
  shares7d: number;
}

export interface DashboardSourceDistributionItem {
  key: string;
  label: string;
  value: number;
}

export interface DashboardOverview {
  cards: DashboardCardMetrics;
  weeklyViews: DashboardWeeklyViewPoint[];
  monthlyTrend: DashboardMonthlyTrendItem[];
  memberGrowth: DashboardMemberGrowthItem[];
  topSolutions: DashboardTopSolutionItem[];
  topTools: DashboardTopToolItem[];
  latestMembers: DashboardLatestMemberItem[];
  recentActivities: DashboardActivityItem[];
  interaction: DashboardInteractionStats;
  sourceDistribution: DashboardSourceDistributionItem[];
}

export function getDashboardOverview() {
  return get<DashboardOverview>('/admin/dashboard/overview');
}
